import { useState } from "react";
import UseFetch from "../components/UseFetch";
import OperationsMagasin from "./ModalOpaerationMagasin";
import OperationsComptable from "./ModalOpaerationsComptable";
import { NavLink } from "react-router-dom";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { fmt } from "../components/const";

const DbComptable = () => {
    const { data, isloading: loader } = UseFetch(`dashboard/comptable`);
    const [titre, setTitre] = useState(null);
    const [type, setType] = useState(null);
    const operations = data?.operations;
    const [solde, setSolde] = useState(0);
    const [isortie, setIsSortie] = useState(false);


    const handleShowModalOperation = (title, type) => {
        setTitre(title);
        setType(type);
    };

    // 🧾 Exporter le PDF
    const exportPDF = () => {
        const doc = new jsPDF("l", "mm", "a4");

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text("FANSAN TEXTIL - COMPTABILITÉ", 14, 15);

        doc.setFontSize(11);
        doc.text("Tableau de bord comptable", 14, 22);

        // 🧮 Tableau des opérations
        autoTable(doc, {
            startY: 28,
            head: [["Indicateur", "Montant (GNF)"]],
            body: [
                ["Solde initial", fmt(operations?.initial)],
                ["Encaissements du jour", fmt(operations?.encaissement)],
                ["Entrées du jour", fmt(operations?.entree)],
                ["Avance fournisseur", fmt(operations?.avance_fourn)],
                ["Remboursements fournisseur", fmt(operations?.remboursement)],
                ["Sorties du jour", fmt(operations?.sortie)],
                ["Versements à la banque", fmt(operations?.banque)],
                ["Dépenses sur conteneur", fmt(operations?.depense)],
                ["Avances sur salaire", fmt(operations?.avances)],
                ["Salaires payés", fmt(operations?.salaires)],
                ["Solde à reporter", fmt(operations?.solde)],
            ],
            theme: "grid",
            headStyles: { fillColor: [0, 102, 204], textColor: 255 },
            styles: { fontSize: 9 },
        });

        // 🪙 Solde argent confié
        if (operations?.solde_confier?.length > 0) {
            const y = doc.lastAutoTable.finalY + 10;
            doc.setFontSize(12);
            doc.text("Solde Argent Confié", 14, y);

            autoTable(doc, {
                startY: y + 5,
                head: [["Montant", "Devise"]],
                body: operations.solde_confier.map((s) => [
                    fmt(s.montant),
                    s.devise,
                ]),
                theme: "grid",
                headStyles: { fillColor: [255, 193, 7], textColor: 20 },
                styles: { fontSize: 9 },
            });
        }

        // 📄 Pied de page
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.text(
                `Page ${i} / ${pageCount}`,
                doc.internal.pageSize.width - 30,
                doc.internal.pageSize.height - 10
            );
        }

        doc.save(`Dashboard_Comptable_${new Date().toISOString().slice(0, 10)}.pdf`);
    };

    return loader ? (
        <div className="loader"></div>
    ) : (
        <div className="dboardMag">
            <div className="row mb-2 p-3 rounded justify-content-between bg-white">
                <div className="col-lg-4">
                    <div className="h4 text-primary">FANSAN TEXTIL - COMPTABILITÉ</div>
                    <span className="text-muted fs-5">Tableau de bord</span>
                    <button
                        onClick={exportPDF}
                        className="btn btn-outline-primary m-1 btn-sm"
                    >
                        📄 Exporter PDF
                    </button>
                </div>

                <div className="col-lg-8 modal-footer">
                    <button
                        className="btn btn-outline-success m-1 btn-sm"
                        data-bs-toggle="modal"
                        data-bs-target="#modalOprationMagasin"
                        onClick={() => {
                            setIsSortie(false);
                            handleShowModalOperation(
                                "Enregistrer une entrée de caisse",
                                "entree"
                            );
                        }}
                    >
                        <i className="bx bx-plus-circle"></i> Entrée de caisse
                    </button>

                    <button
                        className="btn btn-outline-success m-1 btn-sm"
                        data-bs-toggle="modal"
                        data-bs-target="#modalcomptable"
                        onClick={() => {
                            setIsSortie(false);
                            handleShowModalOperation(
                                "Encaisser un versement magasin",
                                "encaissement"
                            );
                        }}
                    >
                        <i className="bx bx-plus-circle"></i> Encaissement magasins
                    </button>

                    <button
                        className="btn btn-outline-danger m-1 btn-sm"
                        data-bs-toggle="modal"
                        data-bs-target="#modalOprationMagasin"
                        onClick={() => {
                            setIsSortie(true);
                            handleShowModalOperation(
                                "Enregistrer une sortie de caisse",
                                "sortie"
                            );
                        }}
                    >
                        <i className="bx bx-plus-circle"></i> Sortie de caisse
                    </button>

                    <button
                        className="btn btn-outline-danger m-1 btn-sm"
                        data-bs-toggle="modal"
                        data-bs-target="#modalOprationMagasin"
                        onClick={() => {
                            setIsSortie(true);
                            handleShowModalOperation(
                                "Faire un versement bancaire",
                                "banque"
                            );
                        }}
                    >
                        <i className="bx bx-plus-circle"></i> Versement banque
                    </button>


                </div>
            </div>

            {/* Cartes récapitulatives (inchangées) */}
            <div className="row row-cols-1 row-cols-md-2 row-cols-xl-4 shadow rounded p-2">
                {[
                    ["Solde initial", operations?.initial, "primary"],
                    ["Encaissements du jour", operations?.encaissement, "info"],
                    ["Entrées du jour", operations?.entree, "warning"],
                    ["Avance fournisseur", operations?.avance_fourn, "danger"],
                    ["Remboursements fournisseur", operations?.remboursement, "danger"],
                    ["Sorties du jour", operations?.sortie, "danger"],
                    ["Versements à la banque", operations?.banque, "danger"],
                    ["Dépenses sur conteneur", operations?.depense, "danger"],
                    ["Avances sur salaire", operations?.avances, "danger"],
                    ["Salaires payés", operations?.salaires, "danger"],
                ].map(([label, value, color], i) => (
                    <div className="col my-1" key={i}>
                        <div
                            className={`card h-100 radius-10 border-start border-0 border-3 border-${color}`}
                        >
                            <div className="py-4 card-body">
                                <p className={`mb-0 text-${color}`}>{label}</p>
                                <h5 className={`my-1 text-${color}`}>
                                    {fmt(value)} GNF
                                </h5>
                            </div>
                        </div>
                    </div>
                ))}

                <div className="col my-1">
                    <div className="card h-100 radius-10 border-start border-0 border-3 border-success bg-success-subtle">
                        <div className="py-4 card-body">
                            <div className="d-flex align-items-center">
                                <div>
                                    <p className="mb-0 text-success fs-4 fw-bold">
                                        Solde à reporter
                                    </p>
                                    <h5 className="my-1 text-success">
                                        {fmt(operations?.solde)} GNF
                                    </h5>
                                </div>
                                <div className="widgets-icons-2 rounded-circle bg-success text-white p-3 ms-auto">
                                    <img src="./images/solde.png" alt="" className="w-100" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Solde argent confié */}
                <div className="col my-1">
                    <div className="card h-100 radius-10 border-start border-0 border-3 border-warning bg-warning-subtle">
                        <div className="py-4 card-body">
                            <div className="d-flex align-items-center">
                                <div>
                                    <p className="mb-0 text-warning fs-6 fw-bold">
                                        Solde argent confié
                                    </p>
                                    <ul>
                                        {operations?.solde_confier?.map((s, ind) => (
                                            <li key={ind}>
                                                {`${fmt(s.montant)} ${s.devise}`}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="widgets-icons-2 rounded-circle bg-warning text-white p-3 ms-auto">
                                    <img src="./images/solde.png" alt="" className="w-100" />
                                </div>
                            </div>
                            <NavLink to="/confier" className="btn btn-primary mt-3 float-end">
                                Détail
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>

            <OperationsMagasin
                titre={titre}
                type={type}
                droit="comptable"
                solde={operations?.solde}
                isortie={isortie}
            />
            <OperationsComptable titre={titre} type={type} />
        </div>
    );
};

export default DbComptable;
